import axios from './axios';
import config from '../../helpers/config';

export default designIds => (
  axios.get(`${config.designBuilderGetDesignsSummaryPath}/${designIds}`)
);
